module.exports = __webpack_public_path__ + "publish-c72308cd412c3947a04f484aa3488674.svg";